import React, { useState } from 'react';
import { pickTextColorBasedOnBgColor } from 'js/library/utils/helpers';

// STYLES
import { Box, Button, Typography, Zoom } from '@mui/material';

// COMPONENTS
import { ColorSelector } from 'js/components/TriiboComponents/ColorSelector/ColorSelector';
import { ContainerFormSegment } from 'js/components/Clubs/Segmentation/segmentStyles';
import { OutlinedInput } from 'js/components/TriiboComponents/Input/OutlinedInput';

export const AlertColorSettings = ({ alertData, handleColor, handleInputs, showButtonPopup }) => {
  const { buttonLabel, color, description, title, type, url } = alertData;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const renderComponent = () => {
    switch (type) {
      case 'popup':
        return (
          <Zoom in={type === 'popup'} timeout={500}>
            <ContainerFormSegment style={{ width: '100%' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Configurações de cores:
              </Typography>

              <ColorSelector
                label="Cores do pop-up"
                value={color}
                setValue={handleColor}
                displayColorPicker={displayColorPicker}
                setDisplayColorPicker={setDisplayColorPicker}
                required
              />

              {showButtonPopup ? (
                <>
                  <OutlinedInput
                    label="Texto do botão"
                    setValue={handleInputs}
                    value={buttonLabel}
                    required
                  />
                  <OutlinedInput
                    label="URL do botão"
                    setValue={handleInputs}
                    value={url}
                    required
                  />
                  <Typography variant="body1" sx={{ marginTop: '0.6rem' }}>
                    Visualizador de components:
                  </Typography>

                  <div
                    style={{
                      height: '2.2rem',
                      width: '100%',
                      background: color,
                      color: color ? pickTextColorBasedOnBgColor(color) : '#343434',
                      border: '1px solid #aaaa',
                    }}
                  >
                    <p style={{ paddingLeft: '8px' }}>{title ? title : 'Título do pop-up'}</p>
                  </div>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: color,
                        color: color,
                        pointerEvents: 'none',
                        '&:hover': {
                          backgroundColor: color,
                        },
                        cursor: 'not-allowed',
                      }}
                    >
                      Fechar
                    </Button>

                    <Button
                      variant="contained"
                      sx={{
                        background: color,
                        color: color ? pickTextColorBasedOnBgColor(color) : '#FFF',
                        pointerEvents: 'none',
                        '&:hover': {
                          backgroundColor: color,
                        },
                        cursor: 'not-allowed',
                        width: '100%',
                      }}
                    >
                      {buttonLabel ? buttonLabel : 'Digite o texto do botão'}
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Typography variant="body1" sx={{ marginTop: '0.6rem' }}>
                    Visualizador de components:
                  </Typography>
                  <div
                    style={{
                      height: '2.2rem',
                      width: '100%',
                      background: color,
                      color: color ? pickTextColorBasedOnBgColor(color) : '#343434',
                      border: '1px solid #aaaa',
                    }}
                  >
                    <p style={{ paddingLeft: '8px' }}>{title ? title : 'Título do pop-up'}</p>
                  </div>
                </>
              )}
            </ContainerFormSegment>
          </Zoom>
        );

      case 'tarja':
        return (
          <Zoom in={type === 'tarja'} timeout={500}>
            <ContainerFormSegment style={{ width: '100%' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Configurações de cores:
              </Typography>
              <ColorSelector
                label="Cor da tarja"
                value={color}
                setValue={handleColor}
                displayColorPicker={displayColorPicker}
                setDisplayColorPicker={setDisplayColorPicker}
                required
              />
              <Typography variant="body1" sx={{ marginTop: '0.6rem' }}>
                Visualizador de components:
              </Typography>
              <div
                style={{
                  height: '2.2rem',
                  width: '100%',
                  background: color,
                  color: color ? pickTextColorBasedOnBgColor(color) : '#343434',
                  border: '1px solid #aaaa',
                  overflow: 'hidden',
                }}
              >
                <p
                  style={{
                    paddingLeft: '8px',
                    fontWeight: 500,
                    fontSize: '0.9rem',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {description ? description : 'Descrição da tarja'}
                </p>
              </div>
            </ContainerFormSegment>
          </Zoom>
        );
    }
  };

  return <>{renderComponent()}</>;
};
